export const enum ServiceAccountsMutationsNames {
    SetScopedSAList = "setScopedSA",
    SetUnscopedSAList = "setUnscopedSA",
    SetSelected = "setSelectedServiceAccount",
    SetUnscopedSAError = "setUnscopedSAError",
    SetScopedSAError = "setScopedSAError",
    ResetState = "resetState",
}

export const enum ServiceAccountsActionsNames {
    FetchScopedSAList = "fetchScopedSAList",
    FetchUnscopedSAList = "fetchUnscopedSAList",
    SetSelected = "setSelectedServiceAccount",
    ResetState = "resetServiceAccountState",
}

export const enum ServiceAccountsGettersNames {
    ScopedSAList = "scopedSAList",
    UnscopedSAList = "unscopedSAList",
    Selected = "selectedServiceAccount",
    IsSelected = "isSelectedServiceAccount",
}
